/**
 * De onde veio a O.S. preventiva: o componente do plano, o intervalo, a última
 * execução e o previsto — como estavam NA ABERTURA (snapshot), não como estão hoje.
 */
import type { MaintenanceWorkOrderDetailDto } from "@bi/types";
import { fmtNumber } from "../../lib/format";
import { fmtDay } from "./preventive-ui";

const ORIGEM: Record<string, string> = {
  grupo: "Plano do grupo", erp: "Intervalo do ERP", padrao: "Plano padrão", manual: "Ajuste manual",
};

export function WorkOrderPlanCard({ o }: { o: MaintenanceWorkOrderDetailDto }) {
  const snap = o.planSnapshot;
  if (o.type !== "preventive" || !o.planComponents.length) return null;
  if (!snap) {
    return (
      <section className="card p-4">
        <h3 className="font-medium text-gray-900">Plano preventivo de origem</h3>
        <p className="mt-1 text-sm text-gray-500">O estado do plano não foi registrado na abertura desta O.S.</p>
      </section>
    );
  }
  return (
    <section className="card p-4 space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <h3 className="font-medium text-gray-900">Plano preventivo de origem</h3>
        <span className="badge-blue">Gerada pelo Plano Preventivo</span>
        {snap.group && <span className="badge-gray">Grupo {snap.group.name}</span>}
      </div>
      <div className="divide-y divide-gray-100">
        {snap.components.map((c) => (
          <dl key={c.componentCode} className="grid grid-cols-2 gap-x-4 gap-y-2 py-2.5 text-sm sm:grid-cols-5 first:pt-0 last:pb-0">
            <div className="col-span-2 sm:col-span-5">
              <p className="font-medium text-gray-900">{c.label}</p>
              <p className="text-xs text-gray-400">{c.source ? ORIGEM[c.source] ?? c.source : "Origem não registrada"}</p>
            </div>
            <Dado rotulo="Intervalo">
              {[c.intervalKm ? `${fmtNumber(c.intervalKm)} km` : null, c.intervalDays ? `${c.intervalDays} dias` : null].filter(Boolean).join(" ou ") || "—"}
            </Dado>
            <Dado rotulo="Última execução">
              {c.lastExecution
                ? <>{c.lastExecution.odometerKm != null ? `${fmtNumber(c.lastExecution.odometerKm)} km` : "—"}<span className="block text-xs text-gray-400">{fmtDay(c.lastExecution.executedAt)}</span></>
                : "Sem base"}
            </Dado>
            <Dado rotulo="Previsto">
              {c.nextKm != null ? `${fmtNumber(c.nextKm)} km` : c.nextDate ? fmtDay(c.nextDate) : "—"}
              {c.nextKm != null && c.nextDate && <span className="block text-xs text-gray-400">{fmtDay(c.nextDate)}</span>}
            </Dado>
            <Dado rotulo="KM na abertura">{c.currentKm != null ? `${fmtNumber(c.currentKm)} km` : "—"}</Dado>
          </dl>
        ))}
      </div>
    </section>
  );
}

function Dado({ rotulo, children }: { rotulo: string; children: React.ReactNode }) {
  return (
    <div>
      <dt className="text-xs text-gray-500">{rotulo}</dt>
      <dd className="text-gray-800">{children}</dd>
    </div>
  );
}
